module.exports = __webpack_public_path__ + "img/28.2008799d.png";